var _defs, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNumberThreeIconSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 122.88 122.88",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill-rule:evenodd;}.cls-2{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "three-number-round") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0A4997",
    className: "cls-1",
    d: "M61.44,0A61.46,61.46,0,1,1,18,18,61.21,61.21,0,0,1,61.44,0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M61.21,84.91A23.39,23.39,0,0,1,51.63,83a15.9,15.9,0,0,1-6.56-5.14,12.49,12.49,0,0,1-2.41-7.54H55.15A3.85,3.85,0,0,0,56,72.71a5.16,5.16,0,0,0,2.17,1.62,8.07,8.07,0,0,0,3.17.58,7.14,7.14,0,0,0,3-.61,5.08,5.08,0,0,0,2-1.7,4.41,4.41,0,0,0,.71-2.51,3.75,3.75,0,0,0-.83-2.45A5.63,5.63,0,0,0,63.87,66a9.54,9.54,0,0,0-3.55-.61H55.68V56.8h4.64a8.19,8.19,0,0,0,3.27-.61,5.09,5.09,0,0,0,2.2-1.67,3.89,3.89,0,0,0,.78-2.46,4.11,4.11,0,0,0-.65-2.36,4.55,4.55,0,0,0-1.86-1.6,6.22,6.22,0,0,0-2.76-.58,7.27,7.27,0,0,0-3,.6,5.21,5.21,0,0,0-2.09,1.67,4.33,4.33,0,0,0-.78,2.45H43.55a12.55,12.55,0,0,1,2.3-7.4,15.45,15.45,0,0,1,6.28-5.05A21.94,21.94,0,0,1,61.3,38a21.89,21.89,0,0,1,9,1.72,14.68,14.68,0,0,1,6.1,4.71,11.28,11.28,0,0,1,2.18,6.87,8,8,0,0,1-2.63,6.28,11.4,11.4,0,0,1-6.74,2.9v.37c3.68.39,6.46,1.53,8.32,3.37a9.32,9.32,0,0,1,2.74,7,11.14,11.14,0,0,1-2.4,7.12,16,16,0,0,1-6.72,4.86,25.74,25.74,0,0,1-9.89,1.77Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNumberThreeIconSelected);
export default __webpack_public_path__ + "static/media/number-three-icon-selected.e09d0ab4bede41cd74eae886170770d5.svg";
export { ForwardRef as ReactComponent };